import { render } from "./TutorialWinckieelIA.vue?vue&type=template&id=46c52d74&scoped=true"
import script from "./TutorialWinckieelIA.vue?vue&type=script&lang=js"
export * from "./TutorialWinckieelIA.vue?vue&type=script&lang=js"

import "./TutorialWinckieelIA.vue?vue&type=style&index=0&id=46c52d74&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c52d74"]])

export default __exports__